import { useEffect } from 'react';

export default function useBodyLock({ lockScroll = true, lockTouch = true } = {}) {
  useEffect(() => {
    if (lockScroll) document.body.style.overflow = 'hidden';
    if (lockTouch) document.body.style.touchAction = 'none';

    return () => {
      if (lockScroll) document.body.style.overflow = 'auto';
      if (lockTouch) document.body.style.touchAction = 'auto';
    };
  }, [lockScroll, lockTouch]);
}
